export default __webpack_public_path__ + "static/media/icons-upload.6a9bd409.svg";